import Block from '../block'

export default class Number extends Block {
    static title = 'number'

    init() {
        const up = this.getElement('up')
        const down = this.getElement('down')
        const field = this.getElement('field')

        if (up !== null && down !== null && field !== null) {
            up.addEventListener('click', () => (field.value = parseInt(field.value) + 1))
            down.addEventListener('click', () => (field.value = parseInt(field.value) > 1 ? parseInt(field.value) - 1 : 1))
        }
    }
}